// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import extensionDefinitionFileEntity from './entities/extension-definition-file.json';
import extensionDefinitionFileMenu from '../pages/extension-definition-file/menu.json';
import extensionDefinitionFileFullForm from '../pages/extension-definition-file/forms/full.json';
import extensionDefinitionFileContextForm from '../pages/extension-definition-file/forms/context.json';
import extensionDefinitionFileMiniForm from '../pages/extension-definition-file/forms/mini.json';
import extensionDefinitionFileLookupForm from '../pages/extension-definition-file/forms/lookup.json';
import extensionDefinitionFileTableView from '../pages/extension-definition-file/views/table.json';
import extensionDefinitionFileCardsView from '../pages/extension-definition-file/views/cards.json';
import extensionDefinitionFileDashboardView from '../pages/extension-definition-file/views/dashboard.json';

/** Тип запису «Файл визначення» зі сторінками пакета: меню, форми та подання з pages/extension-definition-file/. */
export const extensionDefinitionFileDefinition: IRecordTypeDefinition = {
  ...extensionDefinitionFileEntity,
  views: assembleViewSet({
      table: extensionDefinitionFileTableView,
      cards: extensionDefinitionFileCardsView,
      dashboard: extensionDefinitionFileDashboardView,
  }),
  form: extensionDefinitionFileFullForm,
  forms: { full: extensionDefinitionFileFullForm, context: extensionDefinitionFileContextForm, mini: extensionDefinitionFileMiniForm, lookup: extensionDefinitionFileLookupForm },
  menu: extensionDefinitionFileMenu,
} as IRecordTypeDefinition;
